import React from "react";

/** The padded column of the dashboard pages, up to `maxWidth` (default 1024px). */
export const DashboardContentWrapper = ({
  children,
  maxWidth = 1024
}: {
  children: React.ReactNode;
  maxWidth?: number | string;
}) => {
  return (
    <div
      // A number is pixels; a string is any CSS length, e.g. "100%"
      style={{
        maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth
      }}
      className="box-border w-full px-8 md:!px-8 lg:!px-12"
    >
      {children}
    </div>
  );
};
